import { createContext, useContext, useMemo, useState } from "react";

const ReturnExchangeArchivesValueContext = createContext();
const ReturnExchangeArchivesActionsContext = createContext();

export function ReturnExchangeArchivesContextProvider({ children }) {
    const [returnExchangeArchives, setReturnExchangeArchives] = useState([]);

    const returnExchangeArchivesActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setReturnExchangeArchives(newValues);
                },
                setValue: setReturnExchangeArchives
            }
        },
        []
    )

    return (
        <>
            <ReturnExchangeArchivesActionsContext.Provider value={{ returnExchangeArchives: returnExchangeArchivesActions }}>
                <ReturnExchangeArchivesValueContext.Provider value={{ returnExchangeArchives }}>
                    {children}
                </ReturnExchangeArchivesValueContext.Provider>
            </ReturnExchangeArchivesActionsContext.Provider>
        </>
    );
}

export function useReturnExchangeArchivesValueContextHook(props) {
    const value = useContext(ReturnExchangeArchivesValueContext);

    if (value === undefined) {
        throw new Error('useReturnExchangeArchivesValueContextHook should be used within ReturnExchangeArchivesValueContext');
    }

    return {
        returnExchangeArchives: value.returnExchangeArchives,
    };
}

export function useReturnExchangeArchivesActionsContextHook(props) {
    const value = useContext(ReturnExchangeArchivesActionsContext);

    if (value === undefined) {
        throw new Error('useReturnExchangeArchivesActionsContextHook should be used within ReturnExchangeArchivesActionsContext');
    }

    return {
        returnExchangeArchives: {
            onSet: value.returnExchangeArchives.onSet,
            setValue: value.returnExchangeArchives.setValue
        },
    };
}